import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import ProjectWaitForWithdrawTableWidget from '../../widgets/admin/ProjectWaitForWithdrawTableWidget'
import WithdrawalPanel from '../../widgets/admin/WithdrawalPanel'
import { getReviewerPaymentInitialPageApprover } from '../../redux/actions/withdrawReviewPayment'
import { sessionGetItemJSON, sessionRemoveItem } from '../../utils/sessionHelpers'

export default function ApproveWithdrawReview() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [projectVersionId, setProjectVersionId] = useState()
  const [projectReviewerPaymentId, setProjectReviewerPaymentId] = useState()
  const [showTableDetail, setShowTableDetail] = useState(true)
  const [isApproveSuccess, setIsApproveSuccess] = useState(false)

  const code = localStorage.getItem('thp_user_code')
  const projectReviewerPayment = sessionGetItemJSON('projectReviewerPayment')

  useEffect(() => {
    console.log('projectReviewerPayment', projectReviewerPayment)
    if (projectReviewerPayment && projectReviewerPayment?.paymentType == 2) {
      handleOnSelectedRowData(projectReviewerPayment)
      sessionRemoveItem('projectReviewerPayment')
    } else {
      handleGetSchema()
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getReviewerPaymentInitialPageApprover(null)
      setSchema(response.model)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errorMessage,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnSelectedRowData = async (rowData) => {
    setIsLoading(true)
    startLoading()

    setProjectVersionId()
    setProjectReviewerPaymentId()
    setIsApproveSuccess(false)

    try {
      console.log(rowData)
      //const response = await getReviewerPaymentInitialPageApprover(rowData.projectReviewerPaymentId)
      const response = await getReviewerPaymentInitialPageApprover(
        rowData.projectVersionId,
        rowData.projectReviewerPaymentId || null,
        rowData.status
      )

      response.model.forms.projectBudgetPlan.masterBudgetPlan.label = 'แผนงบประมาณ'
      response.model.forms.header =
        rowData?.code + ' ' + rowData?.projectName || response.model.forms.header
      // console.log('res => ', response.model.forms.projectBudgetPlan.masterBudgetPlan.label)
      setShowTableDetail(false)
      setProjectVersionId(rowData.projectVersionId)
      setProjectReviewerPaymentId(rowData.projectReviewerPaymentId)
      setSchema(response.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnCancelShowTable = () => {
    setShowTableDetail(true)
    setProjectVersionId()
    setProjectReviewerPaymentId()
    setIsApproveSuccess(false)
  }

  if (error) {
    return (
      <SidebarProposal isReviewPayment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
      // <div className="custom-dashboard">
      //   <TopLevelNav />
      //   <PageToolbar />
      //   <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      // </div>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReviewPayment>
        <PanalLoadingTemplate />
      </SidebarProposal>
      // <div className="custom-dashboard">
      //   <TopLevelNav />
      //   <PageToolbar />
      //   <PanalLoadingTemplate />
      // </div>
    )
  }

  return (
    <SidebarProposal isReviewPayment>
      {/* <div className="custom-dashboard">
      <TopLevelNav />
      <PageToolbar /> */}

      <ContentHeader
        header={
          code === 'THP-SystemAdmin' ||
          code === 'THP-CallCenter' ||
          code === 'THP-DeptAdmin' ||
          code === 'THP-Manager' ||
          code === 'THP-AsstManager'
            ? 'อนุมัติเบิกจ่ายค่าตอบแทนการทบทวนโครงการ'
            : schema.header
        }
        subHeader={schema.subHeader}
      />

      <Panel
        header={
          code === 'THP-SystemAdmin' ||
          code === 'THP-CallCenter' ||
          code === 'THP-DeptAdmin' ||
          code === 'THP-Manager' ||
          code === 'THP-AsstManager'
            ? 'อนุมัติเบิกจ่ายค่าตอบแทนการทบทวนโครงการ'
            : schema.header
        }
        shaded
        collapsible
        bordered
        defaultExpanded
      >
        <ProjectWaitForWithdrawTableWidget
          onSelectedRowData={handleOnSelectedRowData}
          isApproveTable={true}
          onShow={showTableDetail}
          onChangeShow={() => setShowTableDetail(!showTableDetail)}
          isApproveSuccess={isApproveSuccess}
          statusOptions={schema?.forms?.statusOptions || []}
          statusOptionsForApprover={schema?.forms?.statusOptionsForApprover || []}
        />
        <br />
        {schema.forms && projectVersionId && (
          <WithdrawalPanel
            schema={schema.forms}
            projectVersionId={projectVersionId}
            projectPaymentReviewId={projectReviewerPaymentId}
            onCancelShowTable={handleOnCancelShowTable}
            onSuccess={() => setIsApproveSuccess(true)}
          />
        )}
        <br />
      </Panel>
      {/* </div> */}
    </SidebarProposal>
  )
}
